<template>
	<div :class="{ 'show-border': showBorder }" v-if="user" :title="user?.name || user?.email">
		<v-avatar :size="size" :color="colorAvatar">
			<SIcon :name="user.icon" v-if="user.icon" />
			<img :src="avatarSrc" v-else-if="avatarSrc" :alt="user?.name || user?.email" />
			<div class="initials" v-else-if="initials">
				{{ fullNameInitials }}
			</div>
			<span class="letter" style="font-size: 22px; color: white; font-weight: 300" v-else>
				{{ letter }}
			</span>
		</v-avatar>
	</div>
</template>

<script>
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service';

export default {
	name: 'SettingsManageUsersInfoAvatar',
	components: {},
	props: {
		user: { type: Object },
		size: { type: Number, default: 40 },
		shorten: { type: Boolean, default: false },
		initials: { type: Boolean, default: false },
		showBorder: { type: Boolean, default: false },
		showName: { type: Boolean, default: false },
	},
	computed: {
		colorAvatar() {
			return this.user?.icon ? '#FFFFFF' : '#781DA2';
		},
		avatarSrc() {
			return AppAvatarService.getAvatarSrc(this.user);
		},
		letter() {
			return AppAvatarService.getShortenedName(this.user) || AppAvatarService.getAvatarLetter(this.user);
		},
		fullNameInitials() {
			if (!this.user) {
				return '?';
			}
			return this.user.name
				?.split(' ')
				.map((word, i) => (i < 3 ? word.charAt(0) : ''))
				.join('');
		},
	},
	methods: {},
	watch: {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.show-border {
	border-radius: 50%;
	border: 2px solid var(--white);
}
.initials {
	font-size: 12px;
	font-weight: 300;
	user-select: none;
	color: var(--white);
}
.letter {
	text-transform: uppercase;
}
</style>
